import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PRIORIDADE_SIM_NAO_FORM_IDS, TicketService } from '../../_services/ticket.service';

@Component({
  selector: 'app-priority-overlay',
  templateUrl: './priority-overlay.component.html',
  styleUrls: ['./priority-overlay.component.css']
})
export class PriorityOverlayComponent implements OnInit, OnDestroy {
  isVisible = false;
  selectedPriority: string = '';
  justification: string = '';
  isSimNao = false;
  private subscription: Subscription;

  constructor(private ticketService: TicketService) {}

  ngOnInit(): void {
    this.subscription = this.ticketService.getPriorityRequest().subscribe((formId) => {
      this.show(formId);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  show(formId: number): void {
    this.justification = '';
    this.isSimNao = PRIORIDADE_SIM_NAO_FORM_IDS.includes(formId);
    this.selectedPriority = this.isSimNao ? 'NAO' : '';
    this.isVisible = true;
    document.body.style.overflow = 'hidden';
  }

  hide(): void {
    this.isVisible = false;
    document.body.style.overflow = '';
  }

  get canConfirm(): boolean {
    if (!this.selectedPriority) {
      return false;
    }
    return this.selectedPriority !== 'SIM' || this.justification.trim().length > 0;
  }

  onCancel(): void {
    this.hide();
    this.ticketService.sendPriorityResponse(null);
  }

  onConfirm(): void {
    if (this.canConfirm) {
      this.hide();
      this.ticketService.sendPriorityResponse({
        priority: this.selectedPriority,
        justification: this.selectedPriority === 'SIM' ? this.justification.trim() : undefined,
      });
    }
  }

  selectPriority(priority: string): void {
    this.selectedPriority = priority;
  }
}
